import { render, staticRenderFns } from "./TedsLauncherNotch.vue?vue&type=template&id=6072d60a&"
import script from "./TedsLauncherNotch.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherNotch.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherNotch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports